export interface IUserPreferences {
    numberOfDocumentsPerPage?: number;
    viewNotesComponentsInEditMode?: boolean;
    highlightTodosInNotes?: boolean;
    dontShowAgainConfirmationModalToMarkAllTasksDone?: MarkAllAsDonePreference;
}

export type MarkAllAsDonePreference = {
    action: 'yes' | 'no';
    dontShowAgain: boolean;
};
